import React from 'react'
import Layout from "../components/Common/Layout";
import LeadGenForm from "../components/LeadGenFrom/LeadGenForm";

const LeadGenFormPage = () => {
  return (
    <Layout>
      <LeadGenForm />
    </Layout>
  );
}

export default LeadGenFormPage

